import React from "react";

import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import AspectRatioIcons from "./AspectRatioIcons";
import TextIconButton from "./TextIconButton";
import useCropperContext from "../context/cropper";
import useEditorContext from "../context/editor";
import { usePerformCrop } from "../customHooks/usePerformCrop";

export default function ButtonBar() {
  const { editingMode, setEditingMode, setIsEdit, setIsProcessing } =
    useCropperContext();
  const { setAspectRatio, onSave, onPickImage } = useEditorContext();
  const performCrop = usePerformCrop();
  const tailwind = useTailwind();

  function leftButton() {
    switch (editingMode) {
      case "view":
        return (
          <TextIconButton
            icon="crop"
            text="Editar"
            onPress={() => setEditingMode("crop")}
          />
        );
      case "crop":
        if (setAspectRatio) {
          return (
            <TextIconButton
              icon="crop-free"
              text="Reset"
              onPress={() => setAspectRatio(null)}
            />
          );
        } else if (onPickImage) {
          return (
            <TextIconButton
              icon="image"
              text="Otra imagen"
              onPress={async () => {
                setTimeout(() => setIsProcessing(true), 1000);
                await onPickImage();
                setIsProcessing(false);
              }}
            />
          );
        } else {
          return null;
        }
      case "operation-select":
        return null;
    }
  }
  function rightButton() {
    switch (editingMode) {
      case "view":
        return (
          <TextIconButton icon="check" text="Confirmar" onPress={onSave} />
        );
      case "crop":
        return (
          <TextIconButton
            icon="crop"
            text="Cortar"
            onPress={async () => {
              await performCrop();
              setIsEdit(true);
            }}
          />
        );
      case "operation-select":
        return (
          <TextIconButton icon="check" text="Confirmar" onPress={onSave} />
        );
    }
  }

  return (
    <View style={tailwind("flex-row justify-between items-center mx-4 h-12")}>
      <View style={tailwind("flex-1")}>{leftButton()}</View>
      <AspectRatioIcons />
      <View style={tailwind("flex-1")}>{rightButton()}</View>
    </View>
  );
}
